const flutterTravel = {
  en: {
    flutterTravel: {
      title: 'Travelling',
      description: 'Medical expenses',
      instructions: 'Instructions',
      'instructions.description': 'Procedure for obtaining insurance aid',
      'instructions.kz': 'Phone calls within Kazakhstan is free of charge',
      'instructions.world': 'For international calls',
      'instructions.whatsapp': 'Write to WhatsApp',
      'instructions.title': 'Instructions Travel Insurance',
      'acc1.title': 'Client Actions',
      'acc1.text1':
        'In order to receive emergency medical and other assistance, you need to do the following:',
      'acc1.text2':
        '1. Please contact the 24-hour BALT ASSISTANCE LTD Service Centre by phone, SMS or SKYPE',
      'acc1.text3': '2. Please provide the following information:',
      'acc1.text4':
        'Your name, first name, the number of this insurance contract, its period of validity and the number of the General Contract;',
      'acc1.text5':
        'The information that you are insured with Alatau City Garant Insurance Company Joint Stock Company;',
      'acc1.text6': 'Reason for seeking assistance;',
      'acc1.text7': 'Your location (country, city);',
      'acc1.text8':
        '3. Code and telephone number by which the coordinator of BALT ASSISTANCE LTD shall be able to contact you.',
      'acc2.title': 'List of documents:',
      'acc2.text1': '1. A statement of the insured event;',
      'acc2.text2': '2. Insurance contract;',
      'acc2.text3': "3. A copy of the Insured Person's identity document;",
      'acc2.text4':
        "4. an original invoice from the medical institution (on letterhead or with an appropriate stamp), indicating the patient's name, diagnosis, date of treatment, duration of treatment, list of services rendered and their date and cost, and the total amount to be paid;",
      'acc2.text5':
        "5. Originals of the prescriptions issued by a doctor for this illness, with the pharmacy's stamps and an indication of the cost of each medicine purchased;",
      'acc2.text6':
        "6. A physician's referral for laboratory tests and the invoice of the laboratory with the dates, names and costs of the services provided;",
      'acc2.text7':
        '7. Original copies of receipts evidencing payment for treatment, medicines and other services;',
      'acc2.text8':
        '8. An abstract from the medical record and/or a medical report from the treating Physician;',
      'acc2.text9':
        '9. Documents of travel (tickets) purchased by the Policyholder (Insured Person) from the departure point to the destination point and return tickets;',
      'acc2.text10':
        '10. In case of death of the Insured - a notarized copy of death certificate;',
      'acc2.text11':
        '11. If necessary - other documents relevant to the insured event. ',
      'acc2.text12':
        'More detailed information on the list of documents to be submitted can be obtained from the specialists of the Medical Insurance Department Dinara Kebekpayeva, Oksana Arutyunyants',
    },
  },
  kz: {
    flutterTravel: {
      title: 'Саяхат',
      description: 'Медициналық шығындар',
      instructions: 'Нұсқаулықтар',
      'instructions.description':
        'Сіздің сақтандыру көмегін алу үшін әрекет ету тәртібіңіз',
      'instructions.kz': 'Қазақстан бойынша қоңырау шалу тегін',
      'instructions.world': 'Халықаралық қоңыраулар үшін',
      'instructions.whatsapp': 'WhatsApp-ға жазу',
      'instructions.title': 'Саяхаттаушыларды сақтандыру нұсқаулығы',
      'acc1.title': 'Клиенттің әрекеттері',
      'acc1.text1': 'Сізге шұғыл медициналық және басқа көмек алу үшін:',
      'acc1.text2':
        '1. BALT ASSISTANCE LTD сервистік компаниясының тәулік бойы көмек көрсету орталығына телефон арқылы немесе SMS немесе SKYPE арқылы хабарласу керек',
      'acc1.text3': '2. Келесі ақпаратты:',
      'acc1.text4':
        'Сіздің тегіңізді, атыңызды, осы сақтандыру шартының нөмірі, оның қолданылу мерзімі және бас шарттың нөмірін;',
      'acc1.text5':
        'Сіз «Alatau City Garant» сақтандыру компаниясы акционерлік қоғамында сақтандырылғаныңызды;',
      'acc1.text6': 'Көмек сұраудың себебін;',
      'acc1.text7': 'Сіздің орналасқан жеріңізді (ел, қала) хабарлау қажет;',
      'acc1.text8':
        '3. BALT ASSISTANCE LTD үйлестірушісі сізбен байланыса алатын код және телефон нөмірі.',
      'acc2.title': 'Құжаттар тізімі',
      'acc2.text1': '1. Сақтандыру жағдайы туралы өтініш;',
      'acc2.text2': '2. Сақтандыру шарты;',
      'acc2.text3':
        '3. Сақтанушының жеке басын куәландыратын құжаттың көшірмесі;',
      'acc2.text4':
        '4. Пациенттің тегі, диагнозы, медициналық көмекке жүгінген күні, емдеу ұзақтығы, көрсетілген қызметтер тізбесі көрсетілген медициналық мекемеден анықтама-шоттың түпнұсқасы (фирмалық бланкіде немесе тиісті мөртабанмен), оларды күні мен құны бойынша бөле отырып, төлемнің қорытынды сомасы;',
      'acc2.text5':
        '5. Дәріхана мөртабандарымен және сатып алынған әрбір дәрі-дәрмектің құнын көрсетумен осы ауруға байланысты дәрігер тағайындаған рецепттердің түпнұсқалары;',
      'acc2.text6':
        '6. Дәрігерді зертханалық зерттеулерден өтуге жіберу және көрсетілген қызметтердің күні, атауы және құны бойынша бөлінген зертхана шоты;',
      'acc2.text7':
        '7. Емдеу, дәрі-дәрмек және басқа да қызметтер үшін ақы төлеу фактісін растайтын қазыналық құжаттардың түпнұсқалары;',
      'acc2.text8':
        '8. Емдеуші дәрігердің ауру тарихынан үзінді және (немесе) медициналық қорытындысы;',
      'acc2.text9':
        '9. Сақтанушы (сақтандырылушы) сатып алған жөнелту пунктінен межелі пунктке дейін және кері қайтуға жол жүру құжаттары (билеттері);',
      'acc2.text10':
        '10. Сақтанушы қайтыс болған жағдайда-қайтыс болу туралы куәліктің нотариалды куәландырылған көшірмесі;',
      'acc2.text11':
        '11. Қажет болған жағдайда-сақтандыру жағдайына қатысы бар басқа құжаттар.',
      'acc2.text12':
        'Ұсынылатын құжаттар тізімі бойынша толық ақпаратты Медициналық сақтандыру департаментінің мамандары Динара Кебекпаевадан, Оксана Арутюнянцтан алуға болады.',
    },
  },
  ru: {
    flutterTravel: {
      title: 'Путешествия',
      description: 'Медицинские расходы',
      instructions: 'Инструкции',
      'instructions.description':
        'Ваш порядок действий для получения страховой помощи',
      'instructions.kz': 'Звонок по Казахстану бесплатный',
      'instructions.world': 'Для международных звонков',
      'instructions.whatsapp': 'Написать в WhatsApp',
      'instructions.title': 'Инструкция Страхование путешествующих',
      'acc1.title': 'Действия клиента',
      'acc1.text1':
        'Для получения экстренной медицинской и другой помощи Вам необходимо:',
      'acc1.text2':
        '1. Связаться с круглосуточным Центром помощи Сервисной компании BALT ASSISTANCE LTD по телефонам, либо посредством SMS или SKYPE',
      'acc1.text3': '2. Сообщить следующую информацию:',
      'acc1.text4':
        'Вашу фамилию, имя, номер настоящего договора страхования, срок его действия и номер Генерального договора;',
      'acc1.text5':
        'Что вы застрахованы в компании Акционерное общество Страховая компания «Alatau City Garant»;',
      'acc1.text6': 'Причину обращения за помощью;',
      'acc1.text7': 'Ваше местонахождение (страна, город);',
      'acc1.text8':
        '3. Код и номер телефона, по которому координатор BALT ASSISTANCE LTD может связаться с Вами.',
      'acc2.title': 'Список документов',
      'acc2.text1': '1. Заявление о страховом случае;',
      'acc2.text2': '2. Договор страхования;',
      'acc2.text3':
        '3. Копию документа, удостоверяющего личность Застрахованного;',
      'acc2.text4':
        '4. Оригинал справки-счета из медицинского учреждения (на фирменном бланке или с соответствующим штампом) с указанием фамилии пациента, диагноза, даты обращения за медицинской помощью, продолжительности лечения, перечнем оказанных услуг с разбивкой их по датам и стоимости, итоговой суммы к оплате;',
      'acc2.text5':
        '5. Оригиналы выписанных врачом в связи с данным заболеванием рецептов со штампами аптеки и указанием стоимости каждого приобретенного медикамента;',
      'acc2.text6':
        '6. Направление врача на прохождение лабораторных исследований и счет лаборатории с разбивкой по датам, наименованию и стоимости оказанных услуг;',
      'acc2.text7':
        '7. Оригиналы фискальных документов, подтверждающие факт оплаты за лечение, медикаменты и прочие услуги;',
      'acc2.text8':
        '8. Выписку из истории болезни и (или) медицинское заключение лечащего врача;',
      'acc2.text9':
        '9. Проездные документы (билеты) от пункта отправления до пункта назначения и обратно, приобретенные Страхователем (Застрахованным);',
      'acc2.text10':
        '10. В случае смерти Застрахованного - нотариально заверенную копию свидетельства о смерти;',
      'acc2.text11':
        '11. При необходимости - другие документы, имеющие отношение к страховому случаю. ',
      'acc2.text12':
        'Более полную информацию по перечню предоставляемых документов можно получить у специалистов Департамента Медицинского Страхования Кебекпаевой Динары, Арутюнянц Оксаны.',
    },
  },
};

export default flutterTravel;
